import { v4 as uuidv4 } from 'uuid';
import { CreateDefaultPluginSettingsView } from '../view/CreateDefaultPluginSettingsView';

export const CreateDefaultPluginSettingsTab = (): ITab => {

    return {
        id: uuidv4(),
        title: 'Настройки интерфейса',
        view: {
            content: <CreateDefaultPluginSettingsView />
        }
    }
}